type Bbox = { west: number; south: number; east: number; north: number }

const CONUS_BBOX: Bbox = { west: -125, south: 24, east: -66, north: 50 }

const CANADA_WEST_49TH_PARALLEL_BBOX: Bbox = { west: -141, south: 49, east: -83, north: 83.5 }
const CANADA_EAST_MARITIMES_BBOX: Bbox = { west: -83, south: 41.5, east: -52, north: 83.5 }

const bboxesIntersect = (a: Bbox, b: Bbox) =>
    a.west <= b.east && a.east >= b.west && a.south <= b.north && a.north >= b.south

export const getFireDangerRegionsInView = (viewportBbox: Bbox) => ({
    usInView: bboxesIntersect(viewportBbox, CONUS_BBOX),
    caInView:
        bboxesIntersect(viewportBbox, CANADA_WEST_49TH_PARALLEL_BBOX) ||
        bboxesIntersect(viewportBbox, CANADA_EAST_MARITIMES_BBOX),
})
